import { useEffect } from 'react';

/**
 * Hook which executes before the unmount of a component
 * @param target
 */
export const useComponentWillUnmount = (target: () => void) => {
    useEffect(() => () => target && target(), []);
};
